import { useCallback } from 'react'
import { useFilterFieldsContext } from '../../../context'

export type UseSectionCompositionParams = {
  groupsLength: number
  setGroupPosition: (position: number | ((prev: number) => number)) => void
}

export type UseSectionCompositionResult = {
  composition: string
  groupsLength: number
  handleComposition: (composition: string) => void
  handleCreateGroup: () => void
}

const useSectionComposition = ({
  setGroupPosition,
  groupsLength
}: UseSectionCompositionParams): UseSectionCompositionResult => {
  const {
    form: {
      initialGroupedFieldValues,
      composition,
      handleChange,
      handleComposition
    }
  } = useFilterFieldsContext()

  const initialFieldValues = initialGroupedFieldValues[1]

  const handleCreateGroup = useCallback(() => {
    handleChange({
      [groupsLength + 1]: initialFieldValues
    })
    setGroupPosition((currentGroup) => currentGroup + 1)
  }, [groupsLength, handleChange, initialFieldValues, setGroupPosition])

  return {
    composition,
    groupsLength,
    handleComposition,
    handleCreateGroup
  }
}

export default useSectionComposition
